var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoBarcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.79,20l-4.61-4.61v.11h-1.9v-2l-1.91-1.91V15.5H9.42V10.63l-.95-1V15.5H5.61V6.82l-1-1V15.5h-1V4.91L0,1.21,1.22,0l9.15,9.15,1.91,1.92h0l1.9,1.9h0l1,.95h0l1.58,1.59h0L20,18.79,18.79,20M14.18,4.07h-1.9V8.64l1.9,1.9V4.07m-3.81,0H9.42V5.78l.95,1V4.07m7.62,0H15.13V11.5L18,14.35V4.07M19.9,15.5V4.07h-1V15.3l.19.2h.77M8.47,4.07H7.7l.77.76V4.07M.85,15.5h1.9V4.07H.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoBarcode);
export default __webpack_public_path__ + "static/media/iconNoBarcode.66de20097f425653136b0c206bf8cf4d.svg";
export { ForwardRef as ReactComponent };